import React, { useState } from "react";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn
} from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append(
      "access_key",
      "45ad8c53-0ffe-4d8d-a2cd-3789125ffa29"
    );

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Message sent successfully!");
      event.target.reset();
    } else {
      setResult("Something went wrong. Please try again.");
    }
  };

  return (
    <>
    <section className="contact-section">

      {/* Background Shapes */}
      <div className="bg-shapes">
        <div className="shape shape1"></div>
        <div className="shape shape2"></div>
        <div className="shape shape3"></div>
      </div>

      {/* Breadcrumb */}
      <div className="breadcrumb-wrapper">
        <nav className="app-breadcrumb">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <span className="current">Contact Us</span>
        </nav>
      </div>

      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-left">
          <h2 className="section-title">Get In Touch</h2>

          <p className="section-subtitle">
            We’d love to hear from you! Reach out with questions, ideas,
            or partnership opportunities.
          </p>

          <div className="contact-cards">
            <div className="contact-card">
              <FaEnvelope className="card-icon" />
              <div className="card-text">
                <h4>Email</h4>
                <p>info@fanfaro.in</p>
              </div>
            </div>

            <div className="contact-card">
              <FaPhone className="card-icon" />
              <div className="card-text">
                <h4>Phone</h4>
                <p>+91 72047 31100</p>
              </div>
            </div>

            <div className="contact-card">
              <FaMapMarkerAlt className="card-icon" />
              <div className="card-text">
                <h4>Location</h4>
                <p>
                  335, 2rd Cross Street, JP Nagar 8th Phase,
                  Bengaluru 560076, Karnataka
                </p>
              </div>
            </div>
          </div>

          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61579051466627"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/fanfaroindia?igsh=MXF4cWM3ZjlpenNkdg=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com/company/fanfaro-india/people/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* RIGHT SIDE - FORM */}
        <div className="contact-right">
          <form className="contact-form" onSubmit={onSubmit}>

            <div className="form-group">
              <input type="text" name="name" placeholder=" " required />
              <label>Your Name</label>
            </div>

            <div className="form-group">
              <input type="email" name="email" placeholder=" " required />
              <label>Email Address</label>
            </div>

            <div className="form-group">
              <input type="tel" name="phone" placeholder=" " required />
              <label>Phone Number</label>
            </div>

            <div className="form-group">
              <textarea name="message" rows="5" placeholder=" " required></textarea>
              <label>Message</label>
            </div>

            <button type="submit" className="btn btn-primary contact-btn">
              Send Message
            </button>

            <p className="form-result">{result}</p>

          </form>
        </div>

      </div>
    </section>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
    </>
  );
};

export default Contact;
